import { BPopover } from "bootstrap-vue";
import axios from "axios";
import storeGen from "@/store/main.js";
import themes from "@/styles/themes.js";
import Vue from "vue";
import VueAxios from "vue-axios";
import Vuetify from "vuetify/lib";
import PassWordCheck from "./components/firstAccess/PassWordCheck";
import Vuex from "vuex";
import Vuelidate from "vuelidate";
import "@/styles/customBootstrap.scss";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/styles/base.scss";
import { isSerasa } from "./constants";
Vue.component("b-popover", BPopover);
Vue.component("PassWordCheck", PassWordCheck);
Vue.use(VueAxios, axios);
Vue.use(Vuetify);
Vue.use(Vuex);
Vue.use(Vuelidate);

Vue.config.productionTip = false;

const vuetifyOpts = {
  theme: {
    options: { customProperties: true },
    themes: {
      light: isSerasa ? themes.serasa : themes.light
    }
  }
};

const vuetify = new Vuetify(vuetifyOpts);
const store = storeGen(Vuex);

export { Vue, vuetify, store };
